module.exports = __webpack_public_path__ + "img/suit-05.ebe7b698.png";